import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type StatusKeys = 'createFeedback' | 'registerAnswer' | 'attachFiles';

const initialStatus: Record<StatusKeys, boolean> = {
  createFeedback: false,
  registerAnswer: false,
  attachFiles: true,
};

type FeedbackStore = {
  statusMap: Record<StatusKeys, boolean>;
  setStatus: (key: StatusKeys, value: boolean) => void;
  setStatuses: (patch: Partial<Record<StatusKeys, boolean>>) => void;
  resetStatuses: () => void;
  areAllSuccessfully: () => boolean;
};

export const useFeedbackStore = create<FeedbackStore>()(
  persist(
    (set, get) => ({
      statusMap: initialStatus,

      setStatus: (key, value) =>
        set((state) => ({
          statusMap: { ...state.statusMap, [key]: value },
        })),

      setStatuses: (patch) =>
        set((state) => ({
          statusMap: { ...state.statusMap, ...patch },
        })),

      resetStatuses: () => set({ statusMap: { ...initialStatus } }),
      areAllSuccessfully: () => Object.values(get().statusMap).every(Boolean),
    }),
    {
      name: 'feedback-storage',
      partialize: (state) => ({ statusMap: state.statusMap }),
      version: 1,
    }
  )
);
